import Button from '@platform-ui-common/components/Button/index.js';
import { IconType } from '@platform-ui-common/components/Icon/Icon.types.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import Color, { BackgroundColors } from '@platform-ui-common/utilities/Color.js';
import cx from 'classnames';
import { ReactNode } from 'react';

interface ActionProps {
  onClick: () => void;
  label?: string;
  icon?: IconType;
}

const Actions = ({ actions }: { actions: ActionProps[] }) => {
  if (!actions.length) return null;
  return (
    <div className="flex flex-col md:flex-row items-start gap-6">
      {actions.map(({ onClick, icon = 'edit', label = 'Edit' }) => {
        return (
          <Button
            key={label}
            icon={icon}
            type="button"
            variant="text"
            textColor={Color.Primary}
            onClick={onClick}
            className="text-sm leading-5 font-bold uppercase items-start"
          >
            {label}
          </Button>
        );
      })}
    </div>
  );
};

const FieldList = ({ children }: { children: ReactNode }) => (
  <dl className="inline-grid gap-y-6 w-full grid-cols-1">{children}</dl>
);

const Section = ({
  title,
  children,
  actions = [],
}: { title: ReactNode; children: ReactNode; actions?: ActionProps[] }) => {
  return (
    <div
      className={cx(`${BackgroundColors[Color.LightBackground]} py-6 px-6 lg:px-8 rounded grow`)}
    >
      <div className="flex flex-col md:flex-row gap-6 justify-between mb-3">
        <Typography variant="h3" tag="h2">
          {title}
        </Typography>
        <Actions actions={actions} />
      </div>
      <div className="inline-grid grid-cols-1 md:grid-cols-2 w-3/4">
        <FieldList>{children}</FieldList>
      </div>
    </div>
  );
};

export type { ActionProps };
export { FieldList, Section };
